import { useRouter } from 'next/router';
// Hooks
import { useGetStoreAmas } from 'hooks';
// Helpers
import { getCheapestActiveAma } from 'helpers/ama';
import { trackAddToCartAma } from 'helpers/metrics';
import { getStreamerAvatar } from 'helpers/streams';
import { formatCurrencyString } from 'helpers/formatCurrencyString';
import { isStoreOrganization } from 'helpers/user';
// Constants
import { ORDER_AMA } from 'constants/routes';
// Ui3
import Image from 'ui3/Image/Image';
import Text from 'ui3/Text/Text';
import Button from 'ui3/Button/Button';

import styles from './PromoAma.module.scss';

type PromoAmaProps = {
  storeSlug: string;
};

const PromoAma = ({ storeSlug }: PromoAmaProps) => {
  const router = useRouter();

  const { data } = useGetStoreAmas({
    variables: {
      input: { slug: storeSlug },
    },
  });

  const cheapestActiveAma = getCheapestActiveAma(data?.store?.amas || []);
  const amaPrice = Number(cheapestActiveAma?.price || 0);
  const storeName = data?.store?.storeDetails?.storeName || '';
  const avatarSrc = getStreamerAvatar(data?.store?.storeDetails);

  const handleRequestAmaClick = () => {
    const amaId = cheapestActiveAma?.id || '';
    const amaType = cheapestActiveAma?.type || 'Ama';
    const storeSlug = data?.store?.slug || '';

    router.push(`${ORDER_AMA}/${storeSlug}`).then(() => {
      trackAddToCartAma({
        id: amaId,
        price: amaPrice,
        type: amaType,
        slug: storeSlug,
        storeName,
      });
    });
  };

  if (!cheapestActiveAma || isStoreOrganization(data?.store)) {
    return null;
  }

  return (
    <section className={styles.section}>
      <Image
        className={styles.streamerAvatar}
        src={avatarSrc}
        alt={storeName ? `${storeName} avatar` : 'Athlete avatar'}
        // Eager + real CDN src in SSR (not next/image 1×1 GIF / lazy).
        ssrFill
        priority
      />
      <Text variant="h4" className={styles.title}>
        Ask me anything
      </Text>
      <Text color="lights-medium" textAlign="center" className={styles.text}>
        I’m here to answer your questions about training, about my journey, my
        predictions on the next big event, or anything you want to know. Hit me
        up and ask me anything!
      </Text>
      <Button onClick={handleRequestAmaClick}>
        Request Personal Video {formatCurrencyString(amaPrice)}
      </Button>
    </section>
  );
};

export default PromoAma;
